<script>
import simple from './simple.vue'
import range from './range.vue'
import circle_checkbox from './circle_checkbox.vue'

export default {
  name: "filter-component",
  props: ['spec', 'changeSpecs', 'loading', 'open', 'selected_specs', 'getSpec'],
  components: {simple, range, circle_checkbox},
  data: () => ({
    show: false,
  }),
  watch: {
    open: {
      immediate: true,
      handler: function () {
        this.show = false;
        this.show = !!this.open;
        if(this.selected_specs[this.spec.id]) this.show = true;
      }
    }
  },
}
</script>

<template>
  <transition name="fade">
    <div :class="{'pb-2': show}">
      <div
          class="w-full py-2 px-1.5 text-base hover:bg-gray-lighter cursor-pointer flex justify-between items-center"
          @click="show = !show">
        <p class="p-1 lg:p-0 text-primary font-bold text-sm"> {{ spec.name }}</p>
        <i class="fa-light  text-muted text-xs" :class="show ? 'fa-plus' : 'fa-minus'"></i>
      </div>
      <component :is="spec.component" :spec="spec" :loading="loading" :changeSpecs="changeSpecs" :getSpec="getSpec" v-show="show"
                 class="px-1.5"></component>
    </div>
  </transition>
</template>
